import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';

/**
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many people does your business employ?
 * 
 * == final
 * jobs_t1_total_number
 * 
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many people does your business currently employ?
 * 
 * == baseline
 * jobs_t0_total_number
 * 
 * @param props
 * @returns
 */
export const entrepreneursThatIncreasedNumberOfEmployeesTotalCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );

    const sum = (submissions: any, key: string) => 
        submissions.reduce((acc: number, submission: any) => acc + submission[key] || 0, 0)

    const totalBaselineEmployees = sum(filteredBaseline, 'jobs_t0_total_number');
    const totalFinalEmployees = sum(filteredFinal, 'jobs_t1_total_number');
        
    return (totalBaselineEmployees / totalFinalEmployees * 100).toFixed(2);
}